<template>
  <div id="contratos-toolbar-contratos-ejecucion">
    <v-toolbar flat>
      <template
        v-if="regresar">
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="botonRegresar">
              <v-icon>
                fa-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </template>
      <v-toolbar-title
      :class="{
        'display-1': !$vuetify.breakpoint.xs,
        'display-0': $vuetify.breakpoint.xs
        }">
        {{ titulo }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-if="!$vuetify.breakpoint.xs">
        <v-tooltip bottom color="verde2"
        >
        <template v-slot:activator="{ on, attrs }">
          <custom-button
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            label=""
            iconText="mdi-file-word-outline"
            tipo="agregar"
            @click="generarNuevaPlantilla"
          >
          </custom-button>
        </template>
        <span>Plantillas</span>
        </v-tooltip>

        <v-tooltip bottom color="verde2"
        >
        <template v-slot:activator="{ on, attrs }">
          <custom-button
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            label=""
            iconText="fa-file-pdf"
            tipo="agregar"
            @click="generarPdfInformeGeneral"
          >
          </custom-button>
        </template>
        <span>Informe General</span>
        </v-tooltip>
      </template>
      <!--
      <exportar-excel-reporte-supervision
      >

      </exportar-excel-reporte-supervision>
      -->
    </v-toolbar>
    <v-dialog v-model="mostrarGenerarNuevaPlantilla"
        scrollable
        persistent
        width="800"
        >
          <generar-nueva-plantilla
          modulo="ejecucion"
          :datos="getDatos"
          :idarchivo="titulo"
          ref="generarNuevaPlantilla"
          @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla">
          </generar-nueva-plantilla>
    </v-dialog>
    <v-dialog v-model="mostrarGenerarPdfInformeGeneral"
        scrollable
        width="500"
        >
        <generar-informe-general
        :idContrato="idContrato"
        ref="generarPdfInformeGeneral"
        @cerrarGenerarPdfInformeGeneral="cerrarGenerarPdfInformeGeneral">
        </generar-informe-general>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import GenerarInformeGeneral from '@/components/administracion/ejecucion/informegeneral/Main.vue';
/* import ExportarExcelReporteSupervision from
'@/components/exportar/exceles/ExcelReporteSupervision.vue'; */
import mixDatosContratos from '@/components/administracion/configuracion/plantillas/generador/mixDatosContratos';

export default {
  name: 'TituloToolBarContratoEjecucion',
  props: {
    titulo: {
      type: String,
      required: false,
      default: 'Reportes',
    },
    datos: {
      type: Object,
      required: false,
      default() { return {}; },
    },
    fechas: {
      type: Array,
      required: true,
    },
    regresar: {
      type: Boolean,
      required: false,
      default: false,
    },
    nombreRuta: {
      type: String,
      required: false,
    },
  },
  components: {
    // ExportarExcelReporteSupervision,
    CustomButton,
    GenerarNuevaPlantilla,
    GenerarInformeGeneral,
  },
  mixins: [mixDatosContratos],
  data() {
    return {
      idContrato: this.$route.params.idContrato,
      mostrarGenerarNuevaPlantilla: false,
      mostrarGenerarPdfInformeGeneral: false,
    };
  },
  methods: {
    botonRegresar() {
      const { regresar, nombreRuta } = this;

      if (regresar && nombreRuta) {
        this.$router.push({ name: nombreRuta });
      } else {
        this.$router.back();
      }
    },
    generarNuevaPlantilla() {
      this.mostrarGenerarNuevaPlantilla = !this.mostrarGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },
    generarPdfInformeGeneral() {
      this.mostrarGenerarPdfInformeGeneral = !this.mostrarGenerarPdfInformeGeneral;
    },
    cerrarGenerarPdfInformeGeneral() {
      this.generarPdfInformeGeneral();
    },

  },
  computed: {
    getDatos() {
      if (!this.datos) return {};
      return this.formatoWordContrato(this.datos);
    },
  },
};
</script>

<style lang="scss">

</style>
